import { useQuery } from "@tanstack/react-query";
import { getAnalyticsDashboardConfig } from "@/apis/analytics/analytics-apis";
import { queryKeys } from "./keys";

export function useAnalyticsDashboard(
  whitelabelId: number | null,
  enabled = true
) {
  return useQuery({
    queryKey: queryKeys.analytics.dashboard(whitelabelId),
    queryFn: () => getAnalyticsDashboardConfig(whitelabelId ?? undefined),
    enabled: enabled,
  });
}
